import { request } from 'sonata-react-components';

import type { IASCategories } from 'sonata-static-storage/lib/common/common.types';

export async function getIASCategories(token: Record<string, any>): Promise<IASCategories> {
  return request.makeRequest(
    `${taptap.config.sonataBackendUrl}resources/iasCategories`,
    {
      method: 'GET'
    },
    token
  );
}
